(function () {
  const KLAVIYO_COMPANY_ID = "USe6Bq"; // Public API Key (company_id)
  const KLAVIYO_LIST_ID = "Ts2v47";    // List ID

  // Evita submit duplo quando chamamos form.submit() manualmente
  const SUBMIT_FLAG = "data-klaviyo-submitted";

  function getEmailFromForm(form) {
    // No seu back-in-stock.liquid o campo é name="contact[email]"
    const emailInput =
      form.querySelector('input[name="contact[email]"]') ||
      form.querySelector('input[type="email"]');

    return emailInput ? (emailInput.value || "").trim() : "";
  }

  async function subscribeEmailToKlaviyoList(email, extraProps = {}) {
    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(
      KLAVIYO_COMPANY_ID
    )}`;

    // Payload JSON:API (Client Subscriptions API)
    const payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
                ...extraProps,
              },
            },
          },
          // opcional, ajuda a rastrear a origem
          custom_source: "Back in stock (Shopify)",
        },
        relationships: {
          list: {
            data: {
              type: "list",
              id: KLAVIYO_LIST_ID,
            },
          },
        },
      },
    };

    const res = await fetch(url, {
      method: "POST",
      headers: {
        accept: "application/vnd.api+json",
        "content-type": "application/vnd.api+json",
      },
      body: JSON.stringify(payload),
      // importante quando a página vai navegar logo após o submit
      keepalive: true,
    });

    // Se der erro, vamos logar o body (quando existir) para debug
    if (!res.ok) {
      let errText = "";
      try {
        errText = await res.text();
      } catch (e) {}
      throw new Error(`Klaviyo subscribe failed: ${res.status} ${errText}`);
    }

    return true;
  }

  function attachBackInStockHandler(form) {
    if (!form || form.__klaviyoAttached) return;
    form.__klaviyoAttached = true;

    form.addEventListener("submit", async function (e) {
      // se já passamos por aqui e estamos dando submit programático, não intercepta de novo
      if (form.getAttribute(SUBMIT_FLAG) === "1") return;

      e.preventDefault();

      const email = getEmailFromForm(form);
      if (!email) {
        console.warn("[Klaviyo BIS] Email vazio — não enviando para Klaviyo.");
        form.setAttribute(SUBMIT_FLAG, "1");
        form.submit();
        return;
      }

      // pega algumas infos úteis do form (se tiver)
      const productTitle =
        form.querySelector('textarea[name^="contact["]')?.value || "";

      try {
        console.log("[Klaviyo BIS] Enviando email para Klaviyo:", email);

        await subscribeEmailToKlaviyoList(email, {
          // propriedades extras (opcional)
          $source: "Back in stock",
          product_info: productTitle.slice(0, 500),
        });

        console.log("[Klaviyo BIS] OK — inscrito na lista.");
      } catch (err) {
        // não bloqueia o envio do Shopify, só registra para debug
        console.error("[Klaviyo BIS] Falha ao inscrever na Klaviyo:", err);
      }

      // continua o fluxo normal do Shopify (enviar o contact form)
      form.setAttribute(SUBMIT_FLAG, "1");
      form.submit();
    });
  }

  function init() {
    // Seleciona seu form do snippet back-in-stock.liquid (Shopify contact form)
    // Ele sempre renderiza um <form ...> com inputs contact[email]
    const forms = document.querySelectorAll('form[action^="/contact"]');
    forms.forEach((f) => {
      // Só prende no form que tem o campo de email do back-in-stock
      if (f.querySelector('input[name="contact[email]"]')) {
        attachBackInStockHandler(f);
      }
    });
  }

  // roda quando DOM estiver pronto
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
